// extracted by mini-css-extract-plugin
export default {"title":"MainHeading_title__eHnVN"};